import AddEventContainer from './add_event_container';

const AddEvent = AddEventContainer;
export default AddEvent;
